var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.849 16.396C20.579 15.096 21 13.598 21 12C21 7.029 16.971 3 12 3C7.029 3 3 7.029 3 12C3 16.971 7.029 21 12 21C13.598 21 15.096 20.579 16.396 19.849L21 21L19.849 16.396Z",
    stroke: "#61CDFF",
    strokeWidth: 1.5882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.823 12.323C11.921 12.225 12.079 12.225 12.177 12.323C12.275 12.421 12.275 12.579 12.177 12.677C12.079 12.775 11.921 12.775 11.823 12.677C11.726 12.579 11.726 12.421 11.823 12.323",
    stroke: "#61CDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82299 12.323C7.92099 12.225 8.07899 12.225 8.17699 12.323C8.27499 12.421 8.27499 12.579 8.17699 12.677C8.07899 12.775 7.92099 12.775 7.82299 12.677C7.72599 12.579 7.72599 12.421 7.82299 12.323",
    stroke: "#61CDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.823 12.323C15.921 12.225 16.079 12.225 16.177 12.323C16.275 12.421 16.275 12.579 16.177 12.677C16.079 12.775 15.921 12.775 15.823 12.677C15.726 12.579 15.726 12.421 15.823 12.323",
    stroke: "#61CDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.d1faa5fc97b00c143f7235c9ba746613.svg";
export { ForwardRef as ReactComponent };